export function readStateFromLocation(windowRef, searchParam, pageParam) {
    const url = new URL(windowRef.location?.href ?? 'http://localhost');

    return normalizeState({
        query: url.searchParams.get(searchParam) ?? '',
        page: url.searchParams.get(pageParam) ?? '1',
    });
}

export function buildRequestUrl(pageUrl, windowRef, state, searchParam, pageParam) {
    const url = new URL(pageUrl, windowRef.location?.origin ?? 'http://localhost');

    return applyStateToUrl(url, state, searchParam, pageParam);
}

export function buildPublicUrl(windowRef, state, searchParam, pageParam) {
    const url = new URL(windowRef.location?.href ?? 'http://localhost');

    return applyStateToUrl(url, state, searchParam, pageParam);
}

export function normalizeState(state) {
    const query = typeof state?.query === 'string'
        ? state.query.trim()
        : '';

    return {
        query,
        page: normalizePage(state?.page ?? 1),
    };
}

export function normalizePage(value) {
    if (typeof value === 'number' && Number.isInteger(value)) {
        return value > 1 ? value : 1;
    }

    if (typeof value === 'string' && /^\d+$/.test(value.trim())) {
        const parsed = Number.parseInt(value.trim(), 10);

        return parsed > 1 ? parsed : 1;
    }

    return 1;
}

function applyStateToUrl(url, state, searchParam, pageParam) {
    if (state.query === '') {
        url.searchParams.delete(searchParam);
    } else {
        url.searchParams.set(searchParam, state.query);
    }

    if (state.page <= 1) {
        url.searchParams.delete(pageParam);
    } else {
        url.searchParams.set(pageParam, String(state.page));
    }

    return url;
}
